(function () {
  document.querySelectorAll('[data-sova-reviews]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sova-review]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sova-review-dot]'));
    var prev = root.querySelector('[data-sova-review-prev]');
    var next = root.querySelector('[data-sova-review-next]');
    if (slides.length < 2) return;

    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { show(n); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  });
})();
